<template>
  <reason-list :level="3" />
</template>

<script>
import ReasonList from "./components/ReasonList.vue";

export default {
  name: "ClaimAccidentReasonLevelThree",
  components: { ReasonList }
};
</script>
